import { useEffect, useRef, useState } from "react";

// Inclui tablets em modo retrato, que devem usar a mesma navegacao do celular.
const MOBILE_BREAKPOINT = 1024;

// No desktop, preserva o comportamento atual de menu compacto. No celular,
// o menu inicia oculto e o botão da Topbar alterna sua abertura.
const useResponsiveSidebar = (toggleValue, locationKey) => {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= MOBILE_BREAKPOINT);
  const [mobileOpen, setMobileOpen] = useState(false);
  const previousToggleValue = useRef(toggleValue);
  const sidebarRef = useRef(null);

  useEffect(() => {
    const updateViewport = () => {
      const nextIsMobile = window.innerWidth <= MOBILE_BREAKPOINT;
      setIsMobile(nextIsMobile);
      if (!nextIsMobile) setMobileOpen(false);
    };

    window.addEventListener("resize", updateViewport);
    return () => window.removeEventListener("resize", updateViewport);
  }, []);

  useEffect(() => {
    if (isMobile && previousToggleValue.current !== toggleValue) {
      setMobileOpen((current) => !current);
    }
    previousToggleValue.current = toggleValue;
  }, [isMobile, toggleValue]);

  useEffect(() => {
    if (isMobile) setMobileOpen(false);
  }, [isMobile, locationKey]);

  useEffect(() => {
    if (!isMobile || !mobileOpen) return undefined;

    const closeOnOutsideClick = (event) => {
      const clickedMenu = sidebarRef.current?.contains(event.target);
      const clickedToggle = event.target.closest?.(".menu-toggle-btn");
      if (!clickedMenu && !clickedToggle) setMobileOpen(false);
    };

    document.addEventListener("pointerdown", closeOnOutsideClick);
    return () => document.removeEventListener("pointerdown", closeOnOutsideClick);
  }, [isMobile, mobileOpen]);

  return {
    isMobile,
    mobileOpen,
    sidebarRef,
    closeMobileSidebar: () => setMobileOpen(false),
  };
};

export default useResponsiveSidebar;
